








































































































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import { StoreNamespace } from "@/globals/StoreNamespaceGlobal";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class StatusesManagementComponent extends AfterFetchComponent {
  @Prop(Object) rowSelected!: any;
  @Prop(Boolean) sendExtraText!: any;
  @Prop(Array) rejectStatuses!: any;
  @Prop(Array) underExaminationStatuses!: any;
  @Prop(Boolean) showRemark!: any;
  @Prop(Boolean) showDontSendMassage!: any;
  @Prop(Boolean) isPopupOpen!: boolean;

  @Action('approveApplications', StoreNamespace.PROCESSES) approveApplications: any;
  @Action('rejectApplication', StoreNamespace.PROCESSES) rejectApplication: any;
  @Action('underExaminationApplication', StoreNamespace.PROCESSES) underExaminationApplication: any;
  @Action('getLoansStatusesManagementExtraDetails', StoreNamespace.PROCESSES) getLoansStatusesManagementExtraDetails: any;
  @Action('updateRequestContactInformation', StoreNamespace.PROCESSES) updateRequestContactInformation: any;

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string;

  private rejectStatusesSelection: any[] = [];
  private underExaminationStatusesSelection: any[] = [];
  private dontSendMessage: boolean = false;
  private remarkDescription: string = '';
  private privateRemarkDescription: string = '';
  private emptyBody: string = '';
  private problemWithApplication: boolean = false;
  private loadingAfterSubmit: boolean = false;
  private companyDetailsMailSmsReject: string = "";
  private companyDetailsMailSmsUnderExamination: string = "";
  private companyDetailsMailSmsUnderExaminationExtra: string = "";

  // New reactive properties for editing contact info
  private isEditingContactInfo: boolean = false;
  private newEmail: string = '';
  private newPhoneNumber: string = '';

  mounted() {
    this.getLoansStatusesManagementExtraDetails({
      requestorCallback: this,
    });
    this.privateRemarkDescription = '';
  }

  @Watch('isPopupOpen')
  handleIsPopupOpenChange() {
    if (this.isPopupOpen) {
      this.privateRemarkDescription = this.rowSelected.privateRemark;
    } else {
      this.privateRemarkDescription = '';
    }
  }

  isFinalStatus() {
    if (
        this.rowSelected.loanStatusType &&
        (this.rowSelected.loanStatusType.key === 3 ||
            this.rowSelected.loanStatusType.key === 2)
    ) {
      return true;
    } else {
      return false;
    }
  }

  onManagingCompanyUpdateClick(data: any) {
    if (this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect === 0) {
      this.loadingAfterSubmit = true;
      this.approveLoanRequest([this.rowSelected.id]);
    } else if (this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect === 1) {
      this.loadingAfterSubmit = true;
      this.rejectLoanRequest();
    } else if (this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect === 2) {
      this.loadingAfterSubmit = true;
      this.underExaminationLoanRequest();
    } else {
      return;
    }
    this.privateRemarkDescription = '';
    this.dontSendMessage = false;
  }

  private radioGroupSelectionChanged(selected: any) {
    if (selected === 0) {
      this.underExaminationStatusesSelection = [];
      this.rejectStatusesSelection = [];
    } else if (selected === 1) {
      this.underExaminationStatusesSelection = [];
      this.initRejectOptionsInPopupSelection();
    } else if (selected === 2) {
      this.rejectStatusesSelection = [];
      this.initUnderExaminationReasonInPopupSelection();
    }
  }

  isOtherSection(selected: number) {
    let isOtherSection = false;

    if (selected === 1) {
      if (this.rowSelected.loanApprovalDetailsFormData.selectRejectType) {
        if (this.rowSelected.loanApprovalDetailsFormData.selectRejectType.description === 'אחר.') {
          isOtherSection = true;
        }
      }
    } else if (selected === 2) {
      if (this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType) {
        if (this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType.description === 'אחר.') {
          isOtherSection = true;
        }
      }
    }

    return isOtherSection;
  }

  showDelayOrReject(): boolean {
    return (
        (this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect === 2 &&
            this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType &&
            this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType.description === 'אחר.') ||
        (this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect === 1 &&
            this.rowSelected.loanApprovalDetailsFormData.selectRejectType &&
            this.rowSelected.loanApprovalDetailsFormData.selectRejectType.description === 'אחר.')
    );
  }

  private initRejectOptionsInPopupSelection() {
    this.rejectStatusesSelection = [...this.rejectStatuses];
  }

  private initUnderExaminationReasonInPopupSelection() {
    this.underExaminationStatusesSelection = [...this.underExaminationStatuses];
  }

  private underExaminationLoanRequest(): void {
    let description: string =
        this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType.description;
    let additionalDescription: string = this.remarkDescription;
    let descriptionCode: number = Number.parseInt(
        this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType.value
    );

    if (this.rowSelected.loanApprovalDetailsFormData.selectUnderExaminationType.description === 'אחר.') {
      description = '';
    }

    this.remarkDescription = '';

    this.underExaminationApplication({
      requestorCallback: this,
      requestBody: {
        memberProcessId: this.rowSelected.id,
        description: description,
        additionalDescription: additionalDescription,
        managementCompanyReason: descriptionCode,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage,
      },
    });
  }

  private rejectLoanRequest(): void {
    let description: string =
        this.rowSelected.loanApprovalDetailsFormData.selectRejectType.description;
    let additionalDescription: string = this.remarkDescription;
    let descriptionCode: number = Number.parseInt(
        this.rowSelected.loanApprovalDetailsFormData.selectRejectType.value
    );

    if (this.rowSelected.loanApprovalDetailsFormData.selectRejectType.description === 'אחר.') {
      description = '';
    }

    this.remarkDescription = '';

    this.rejectApplication({
      requestorCallback: this,
      requestBody: {
        memberProcessId: this.rowSelected.id,
        description: description,
        additionalDescription: additionalDescription,
        managementCompanyReason: descriptionCode,
        loanRejectionType: this.rowSelected.loanApprovalDetailsFormData.selectRejectType.name,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage,
      },
    });
  }

  private showSuccessAction() {
    if (!this.problemWithApplication) {
      this.$root.$emit("showAlertNotification", {
        toShow: true,
        message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
        icon: 'checkCircle',
        secondsToDisappear: 5,
      });
    }
  }

  private showErrorAction() {
    if (!this.problemWithApplication) {
      this.$root.$emit("showAlertNotification", {
        toShow: true,
        message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
        icon: 'checkCircle',
        secondsToDisappear: 5,
      });
    }
  }

  private approveLoanRequest(allIds: string[]): void {
    this.approveApplications({
      requestorCallback: this,
      requestBody: {
        memberProcessIds: allIds,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage,
      },
    });
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'approveApplications':
      case 'rejectApplication':
      case 'underExaminationApplication':
        this.onClosePopup();
        this.showSuccessAction();
        this.loadingAfterSubmit = false;
        break;
      case 'getLoansStatusesManagementExtraDetails':
        this.companyDetailsMailSmsReject = data.companyDetailsMailSmsReject;
        this.companyDetailsMailSmsUnderExamination = data.companyDetailsMailSmsUnderExamination;
        this.companyDetailsMailSmsUnderExaminationExtra = data.companyDetailsMailSmsUnderExaminationExtra;
        break;

      case 'updateRequestContactInformation' :
        this.rowSelected.email = this.newEmail;
        this.rowSelected.phoneNumber = this.newPhoneNumber;
        this.isEditingContactInfo = false;
        this.showSuccessAction();
        break
    }
  }

  onError(messages: string[], code: number, requestName?: string) {
    switch (requestName) {
      case 'approveApplications':
      case 'rejectApplication':
      case 'underExaminationApplication':
        const errorMessage: string = messages[0] ? messages[0] : '';
        this.onClosePopupOnRequestFailed(errorMessage);
        this.loadingAfterSubmit = false;
        break;
      case 'updateRequestContactInformation' :
        this.$root.$emit('showAlertNotification', {
          toShow: true,
          message: messages && messages.length > 0 ? messages[0] : 'general_error_msg',
          icon: 'warning',
          secondsToDisappear: 5
        })
        break;
      default:
        this.handleOnError(messages, code, requestName);
    }
  }

  onClosePopup() {
    this.$emit("closePopup");
  }

  onClosePopupOnRequestFailed(messageError: string) {
    this.$emit("closePopupOnRequestFailed", messageError);
  }

  handlePrivateRemarkChanged() {
    if (this.privateRemarkDescription == null) {
      this.privateRemarkDescription = "";
    }
  }

  startEditingContact() {
    this.isEditingContactInfo = true;
    this.newEmail = this.rowSelected.email;
    this.newPhoneNumber = this.rowSelected.phoneNumber;
  }

  cancelEditingContact() {
    this.isEditingContactInfo = false;
  }

  saveContactInfo() {
    const body = {
      id: this.rowSelected.id,
      email: this.newEmail,
      phoneNumber: this.newPhoneNumber
    }

    this.updateRequestContactInformation({
      requestorCallback: this,
      requestBody: body
    });
  }

  get notificationToSendAsMemberWillSee(): string {
    const { rowSelected, mngCompanyName, remarkDescription } = this;
    const formData = rowSelected.loanApprovalDetailsFormData;
    const applicationSelect = formData.loanApplicationSelect;
    let description = '';

    if (applicationSelect === 0) {
      // Approved loan application
      if (rowSelected.loanStatusType.key === 1) {
        return this.createApprovedMessage();
      } else {
        return 'בסטטוס מאשר ראשון לא נשלחת הודעה לעמית.';
      }
    } else if (applicationSelect === 1) {
      // Rejected loan application
      if (!formData.selectRejectType) return '';
      return this.createRejectMessage(formData.selectRejectType);
    } else if (applicationSelect === 2) {
      // Under examination loan application
      if (!formData.selectUnderExaminationType) return '';
      return this.createUnderExaminationMessage(formData.selectUnderExaminationType);
    }

    return this.createDefaultMessage(description);
  }

  private createApprovedMessage(): string {
    const { rowSelected, mngCompanyName } = this;
    return `
    שלום , ${rowSelected.fullName}
    <br>
    בקשתך ל ${rowSelected.requestType} אושרה.
    <br>
    לעיון בפרטי הבקשה לחץ בקישור שלהלן
    <br>
    <a class="text-primary" target="_blank" href="https://optimus-member.malam-payroll.com/#/my-processes/${mngCompanyName.toLowerCase()}">
      https://optimus-member.malam-payroll.com/#/my-processes/${mngCompanyName.toLowerCase()}
    </a>
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private createUnderExaminationMessage(selectType: { description: string }): string {
    const { rowSelected, mngCompanyName } = this;
    return `
    שלום , ${rowSelected.fullName}
    <br>
    בקשתך ל${rowSelected.requestType} ממתינה להשלמת נתונים חסרים.
    <br>
    בהתאם לפירוט להלן:
    <br>
    ${this.getSelectTypeDescription(selectType)}
    <br>
    ${this.companyDetailsMailSmsUnderExamination.replace(/\n/g, '<br>')}
    ${this.companyDetailsMailSmsUnderExaminationExtra.replace(/\n/g, '<br>')}
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private createRejectMessage(selectType: { description: string }): string {
    const { rowSelected, mngCompanyName } = this;
    return `
    שלום , ${rowSelected.fullName}
    <br>
    בקשתך ל${rowSelected.requestType} נדתחתה.
    <br>
    בהתאם להחלטת החברה אינך עומד בתנאים לקבלת הלוואה.
    <br>
    סיבת הדחייה:
    <br>
    ${this.getSelectTypeDescription(selectType)}
    <br>
    ${this.companyDetailsMailSmsReject.replace(/\n/g, '<br>')}
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

  private getSelectTypeDescription(selectType: { description: string }): string {
    if (selectType.description.includes('אחר')) {
      return this.remarkDescription
          ? this.remarkDescription.replace(/\n/g, '<br>')
          : '<b>{**תוכן ההודעה**}</b>';
    }
    return selectType.description;
  }

  private createDefaultMessage(description: string): string {
    const { rowSelected } = this;
    return `
    שלום , ${rowSelected.fullName}
    <br>
    בקשתך ל ${rowSelected.requestType}.
    <br>
    ${description ? description : "{ **תוכן ההודעה** }"}
    <br>
    בברכה,
    <br>
    ${rowSelected.managingCompanyFullName}.
  `;
  }

}
